const Footer = () => {
    return (
      <>
      <footer className="bg-gradient-to-b from-Blue-800 to-Blue-800 py-[90px] w-screen px-7 font-assistant foorer-txt">
          <div className="text-center text-primary-white w-full">
            <p className="flex flex-row gap-7 justify-center mb-4">
              <a href="https://www.teamanics.com/?section=privacy">
                <span className="foorer-txt">Privacy</span>
              </a>

              <a href="https://www.teamanics.com/?section=terms">
                <span className="foorer-txt">Terms</span>
              </a>
            </p>
            <span>
              50 California Street, Suite 1500, San Francisco, CA 94111
            </span>
            <div>
              <a href="">
                <span className="foorer-txt">info@teamanics.com</span>
              </a>
            </div>

            <div className="footer-tc">© 2020 - 2022 Teamanics™</div>
            <div>Teamanics is a trademark and service of Metabyte, Inc.</div>
          </div>
        </footer>
      </>
    );
  };
  export default Footer;